import React from 'react';
import PropTypes from 'prop-types';
import siteStructure from '../../../data/siteStructure';
import MainMenuItem from './MainMenuItem';
import MainMenuSubmenu from './MainMenuSubmenu';

const MainMenu = ({ activeRoute }) => {
  const activeItem = siteStructure.find(item => item.href === activeRoute);
  let activeId = '';
  // If the current route is in the site structure
  if (activeItem) {
    activeId = activeItem.id;
  }

  return (
    <div className="main-menu h-100 overflow-hidden">
      <ul className="main-menu__list faux-list-new h-100">
        {siteStructure
          .filter(i => i.includeInMainMenu === true)
          .map((item) => {
            const { id, parentId, title, href, iconName, submenu } = item;

            return (
              <MainMenuItem key={href} title={title} href={href} iconName={iconName} active={activeId === id || activeId === parentId}>
                {submenu &&
                  <MainMenuSubmenu items={submenu} />
                }
              </MainMenuItem>
            );
          })
        }
      </ul>
    </div>
  );
};

MainMenu.propTypes = {
  activeRoute: PropTypes.string.isRequired,
};

export default MainMenu;



// WEBPACK FOOTER //
// ./library/app/components/Global/Menus/MainMenu.js